/*!
 * jQuery Vertical Carousel
 * https://github.com/haripaddu/jQuery-Vertical-Carousel
 * Version: 1.0
 * License: MIT
 */

(function($) {
    $.fn.force_redraw = function() {
        return this.hide(0, function() {
            $(this).show();
        });
    };

    $.fn.verticalCarousel = function(options) {

        var carouselContainerClass = "vc_container";
        var carouselGroupClass = "vc_list";

        var carouselStageClass = "vc_stage";
        var carouselOuterClass = "vc_outer";

        var carouselGoUpClass = "vc_goUp";
        var carouselGoDownClass = "vc_goDown";

        var defaults = { currentItem: 1, showItems: 1 };
        var options = $.extend(defaults, options);

        var carouselContainer;
        var carouselGroup;
        var carouselStage;
        var carouselOuter;
        var carouselUp;
        var carouselDown;
        var lenghtItems;
        var totalItems;

        // var createDivWithClass = (function (classname) {
        //     var div = document.createElement('div')
        //     div.setAttribute('class', classname)
        //     return div
        // });

        var setContainerHeight = (function() {
            var containerHeight = 0;
            var marginTop = 0;

            var currentItemHigh = options.currentItem + 3;
            $(".verticalCarouselGroup > :nth-child(" + currentItemHigh + ")").addClass('high');
            $(".verticalCarouselGroup > :not(:nth-child(" + currentItemHigh + "))").removeClass('high');

            if (options.showItems == 1) {
                containerHeight = $("> :nth-child(" + options.currentItem + ")", carouselGroup).outerHeight(true);
            } else {
                for (i = options.currentItem; i <= (options.currentItem + options.showItems - 1); i++) {
                    //console.log($("> :nth-child(" + i + ")", carouselGroup).outerHeight(true));
                    containerHeight = containerHeight + $("> :nth-child(" + i + ")", carouselGroup).outerHeight(true);
                }
            }
            // var nextItem = options.showItems + options.currentItem;
            // marginTop = $("> :nth-child(" + nextItem + ")", carouselGroup).css("marginTop");
            // containerHeight = containerHeight - parseInt(marginTop);
            $(carouselContainer).css("height", containerHeight);
        });

        var setOuterWidth = (function() {
            var itemsPrepend = $("li", carouselGroup).clone();
            var itemsAppend = $("li", carouselGroup).clone();
            itemsAppend.appendTo(carouselGroup);
            itemsPrepend.prependTo(carouselGroup);

            var itemsPrepend = $("li", carouselStage).clone();
            var itemsAppend = $("li", carouselStage).clone();
            itemsAppend.appendTo(carouselStage);
            itemsPrepend.prependTo(carouselStage);

            var containerWidth = totalItems * 100 + "%";
            $(carouselStage).css("width", containerWidth);

            $("li", carouselStage).each(function() {
                var itemWith = (100 / (totalItems)) + "%";
                $(this).css("width", itemWith)
            });

        });

        // var updateNavigation = (function(direction){
        //     if (options.currentItem == 1){
        //         $(carouselUp).addClass("isDisabled");
        //     }
        //     else if (options.currentItem > 1){
        //         $(carouselUp).removeClass("isDisabled");
        //     }
        //     if(options.currentItem == totalItems || options.currentItem + options.showItems > totalItems){
        //         $(carouselDown).addClass("isDisabled");
        //     }
        //     else if (options.currentItem < totalItems){
        //         $(carouselDown).removeClass("isDisabled");
        //     }
        // });

        var resetInfinite = (function() {
            if (options.currentItem <= options.showItems) {
                gotoitem(options.currentItem + lenghtItems, false)
            } else if (options.currentItem >= totalItems - options.showItems) {
                gotoitem(options.currentItem - lenghtItems, false)
            }
        });

        var moveCarousel = (function(direction) {
            resetInfinite();
            if (direction == "up") {
                gotoitem(options.currentItem - 1, true)
            }
            if (direction == "down") {
                gotoitem(options.currentItem + 1, true)
            }

            //updateNavigation();


        });

        var gotoitem = (function(index, animation) {
            console.log(index + ':' + animation);

            if (animation === false) {
                $(carouselGroup).css("transition", 'none');
                $(carouselStage).css("transition", 'none');
                // $(carouselGroup).addClass('notransition');
                // $(carouselStage).addClass('notransition');
            }

            options.currentItem = index;
            setContainerHeight();
            setOffset();

            $(carouselGroup).force_redraw(); // force repaint
            $(carouselStage).force_redraw(); // force repaint
            if (animation === false) {
                $(carouselGroup).css("transition", '');
                $(carouselStage).css("transition", '');
                // $(carouselGroup).removeClass('notransition');
                // $(carouselStage).removeClass('notransition');
            }

        });

        var setOffset = (function() {
            // console.log(options.currentItem);
            var currentItemOffset = $("> :nth-child(" + options.currentItem + ")", carouselGroup).offset();
            var carouselGroupOffset = $(carouselGroup).offset();
            var offsetDiff = carouselGroupOffset.top - currentItemOffset.top;
            $(carouselGroup).css({
                // "-ms-transform": "translateY(" + offsetDiff + "px)",
                // "-webkit-transform": "translateY(" + offsetDiff + "px)",
                "transform": "translateY(" + offsetDiff + "px)"
            });

            var offsetStage = -(100 / (totalItems)) * (options.currentItem + 2);
            $(carouselStage).css("transform", "translateX(" + offsetStage + "%)");

        });

        return this.each(function() {
            $(this).find("." + carouselGroupClass).wrap('<div class="' + carouselContainerClass + '"></div>');
            carouselContainer = $(this).find("." + carouselContainerClass);
            carouselGroup = $(this).find("." + carouselGroupClass);
            lenghtItems = $(carouselGroup).children().length;

            $(this).find("." + carouselStageClass).wrap('<div class="' + carouselOuterClass + '"></div>');
            carouselStage = $(this).find("." + carouselStageClass);
            // $(carouselStage).css("transform", "translateX(" + - (100 / totalItems) * 3 + "%)" );
            carouselOuter = $(this).find("." + carouselOuterClass);

            carouselUp = $(this).find("." + carouselGoUpClass);
            carouselDown = $(this).find("." + carouselGoDownClass);

            totalItems = lenghtItems * 3;
            setOuterWidth();
            gotoitem(options.currentItem + lenghtItems, false);


            //updateNavigation();
            // setOuterWidth();
            // setContainerHeight();
            // setOffset();
            $(carouselUp).on("click", function(e) {
                if (options.currentItem > 1) {
                    moveCarousel("down");
                }
                e.preventDefault();
            });
            $(carouselDown).on("click", function(e) {
                if (options.currentItem + options.showItems <= totalItems) {
                    moveCarousel("up");
                }
                e.preventDefault();
            });
        });

    };
})(jQuery);